(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-product-root]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const track = root.querySelector('[data-gallery-track]');
      const slides = [...root.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...root.querySelectorAll('[data-gallery-index]')];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      let active = 0;
      const activate = index => {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        track.scrollTo({ left: active * track.clientWidth, behavior: reduced ? 'instant' : 'smooth' });
      };
      const syncGallery = () => {
        active = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        thumbs.forEach((thumb, index) => {
          thumb.classList.toggle('is-active', index === active);
          if (index === active) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
        });
        const counter = root.querySelector('[data-gallery-counter]');
        if (counter) counter.textContent = (active + 1) + ' / ' + slides.length;
        slides.forEach((slide, index) => { if (index !== active) slide.querySelector('video')?.pause(); });
      };
      if (track) {
        thumbs.forEach(thumb => thumb.addEventListener('click', () => activate(Number(thumb.dataset.galleryIndex))));
        root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => activate(active - 1));
        root.querySelector('[data-gallery-next]')?.addEventListener('click', () => activate(active + 1));
        track.addEventListener('scroll', syncGallery, { passive: true });
        track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); activate(active + (event.key === 'ArrowRight' ? 1 : -1)); }
        });
        syncGallery();
      }
      root.querySelectorAll('[data-open-detail]').forEach(link => link.addEventListener('click', () => {
        const detail = document.getElementById(link.hash.slice(1));
        if (detail instanceof HTMLDetailsElement) detail.open = true;
      }));
      const form = root.querySelector('[data-product-form]');
      if (!form) return;
      let data;
      try { data = JSON.parse(root.querySelector('[data-product-variants]').textContent); } catch { return; }
      const variants = data.variants;
      let sourceVariants = [];
      try { sourceVariants = JSON.parse(root.querySelector('[data-source-variants]')?.textContent || '[]'); } catch { /* Native product form remains usable without enrichment. */ }
      const nutritionContent = root.querySelector('[data-source-nutrition]');
      const initialNutrition = nutritionContent?.innerHTML || '';
      const galleryHero = root.querySelector('.more-gallery__hero');
      const initialHeroStyle = galleryHero?.getAttribute('style') || '';
      const responsiveImage = (src, width) => {
        try {
          const url = new URL(src, location.origin);
          if (url.hostname === 'cdn.shopify.com' || url.hostname === 'morenutrition.de') url.searchParams.set('width', width);
          return url.href;
        } catch { return src; }
      };
      const nativeSelect = form.querySelector('[data-variant-select]');
      const enhanced = form.querySelector('.more-enhanced-options');
      const controls = [...form.querySelectorAll('[data-option-position]')];
      const quantity = form.querySelector('[name="quantity"]');
      root.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
        quantity.value = Math.max(1, (parseInt(quantity.value, 10) || 1) + Number(button.dataset.quantityChange));
      }));
      const selectVariant = (variant, updateUrl = true) => {
        const available = Boolean(variant?.available);
        root.querySelectorAll('[data-add-button]').forEach(button => {
          button.disabled = !available;
          button.textContent = !variant ? 'Nicht verfügbar' : available ? (button.closest('[data-sticky-buy]') ? 'In den Warenkorb' : 'In den Warenkorb legen') : 'Ausverkauft';
        });
        root.querySelector('[data-stock-label]').textContent = available ? 'Auf Lager' : 'Aktuell nicht verfügbar';
        form.querySelector('[data-variant-status]').textContent = !variant ? 'Diese Kombination ist nicht verfügbar. Bitte wähle eine andere Ausführung.' : '';
        nativeSelect.disabled = !variant;
        if (!variant) return;
        nativeSelect.value = String(variant.id);
        const prices = data.prices[String(variant.id)];
        const price = root.querySelector('[data-product-price]');
        price.replaceChildren();
        const strong = document.createElement('strong'); strong.textContent = prices.price; price.append(strong);
        if (variant.compare_at_price > variant.price) { const old = document.createElement('s'); old.textContent = prices.compare; price.append(old); }
        root.querySelector('[data-sticky-price]')?.replaceChildren(document.createTextNode(prices.price));
        root.querySelector('[data-unit-price]').textContent = prices.unit || '';
        const flavorImage = root.querySelector('.more-flavour-select__image');
        const sourceVariant = sourceVariants.find(item => variant.sku && item.sku === variant.sku) || sourceVariants.find(item => item.title === variant.title);
        const variantImage = variant.featured_image?.src || sourceVariant?.image;
        if (variantImage && flavorImage) { flavorImage.src = responsiveImage(variantImage, 160); flavorImage.removeAttribute('srcset'); }
        if (variantImage && galleryHero) {
          const heroImg = galleryHero.querySelector('img');
          heroImg.src = responsiveImage(variantImage, matchMedia('(min-width: 1000px)').matches ? 1400 : 900);
          heroImg.removeAttribute('srcset');
          heroImg.alt = root.querySelector('h1').textContent + ' – ' + variant.title;
          if (sourceVariant?.hero_background || sourceVariant?.hero_splash) {
            galleryHero.style.backgroundColor = sourceVariant.hero_background || '#f3f3f3';
            galleryHero.style.backgroundImage = sourceVariant.hero_splash ? 'url("' + sourceVariant.hero_splash + '")' : 'none';
          } else if (sourceVariant?.title === sourceVariants[0]?.title) galleryHero.setAttribute('style', initialHeroStyle);
          else { galleryHero.style.backgroundColor = '#f3f3f3'; galleryHero.style.backgroundImage = 'none'; }
        }
        if (nutritionContent) {
          if (sourceVariant?.nutrition) {
            nutritionContent.innerHTML = sourceVariant.nutrition + (sourceVariant.ingredients || '');
            const label = document.createElement('p');
            label.className = 'source-variant-label';
            label.textContent = variant.title;
            nutritionContent.prepend(label);
          }
          else nutritionContent.innerHTML = initialNutrition;
        }
        if (!prices.unit && sourceVariant?.unit_price_measurement) {
          const measure = sourceVariant.unit_price_measurement;
          const scales = { g: 1, kg: 1000, mg: 0.001, ml: 1, cl: 10, l: 1000, m: 1, cm: 0.01 };
          const quantityScale = scales[measure.quantity_unit];
          const referenceScale = scales[measure.reference_unit];
          if (quantityScale && referenceScale && Number(measure.quantity_value) > 0) {
            const unitPrice = (variant.price / 100) * Number(measure.reference_value) * referenceScale / (Number(measure.quantity_value) * quantityScale);
            const currency = root.dataset.currency || 'EUR';
            root.querySelector('[data-unit-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency }).format(unitPrice) + ' / ' + measure.reference_value + ' ' + measure.reference_unit;
          }
        }
        const mediaIndex = slides.findIndex(slide => String(slide.dataset.mediaId) === String(variant.featured_media?.id));
        if (updateUrl && mediaIndex >= 0) activate(mediaIndex);
        else if (updateUrl && variantImage && galleryHero) activate(0);
        if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
        const selectedFlavor = variant.options?.[0];
        root.querySelectorAll('[data-nutrition-flavor]').forEach(block => {
          const sourceFlavor = block.dataset.nutritionFlavor;
          let note = block.querySelector('.more-nutrition-note');
          if (sourceFlavor && selectedFlavor && sourceFlavor !== selectedFlavor) {
            if (!note) { note = document.createElement('p'); note.className = 'more-nutrition-note'; block.prepend(note); }
            note.textContent = 'Diese Angaben gelten für ' + sourceFlavor + ', nicht für die gewählte Sorte ' + selectedFlavor + '. Bitte prüfe die Angaben auf der Verpackung.';
          } else note?.remove();
        });
      };
      controls.forEach(control => control.addEventListener('change', () => {
        const values = [];
        controls.forEach(input => { if (input.tagName === 'SELECT' || input.checked) values[Number(input.dataset.optionPosition)] = input.value; });
        selectVariant(variants.find(variant => variant.options.every((value, index) => value === values[index])));
      }));
      nativeSelect.addEventListener('change', () => {
        const variant = variants.find(item => String(item.id) === nativeSelect.value);
        if (variant) controls.forEach(input => { const value = variant.options[Number(input.dataset.optionPosition)]; if (input.tagName === 'SELECT') input.value = value; else input.checked = input.value === value; });
        selectVariant(variant);
      });
      if (enhanced) { enhanced.hidden = false; form.querySelector('.more-variant-fallback').hidden = true; }
      selectVariant(variants.find(item => String(item.id) === nativeSelect.value), false);
      form.addEventListener('submit', event => { if (nativeSelect.disabled || !nativeSelect.value) event.preventDefault(); });
      const sticky = root.querySelector('[data-sticky-buy]');
      const mainButton = form.querySelector('[data-add-button]');
      if (sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        }, { threshold: 0 }).observe(mainButton);
      }
    });
    scope.querySelectorAll('[data-bundle-form]').forEach(form => {
      if (form.dataset.initialized) return; form.dataset.initialized = 'true';
      const sync = () => {
        let count = 0;
        form.querySelectorAll('[data-bundle-item]').forEach(item => {
          const checked = item.querySelector('[type="checkbox"]').checked;
          item.querySelectorAll('select,input[type="hidden"]').forEach(control => { control.disabled = !checked; });
          if (checked) count++;
          const select = item.querySelector('select');
          const selectedPrice = select?.selectedOptions[0]?.dataset.price;
          if (selectedPrice) item.querySelector('[data-bundle-price]').textContent = selectedPrice;
          const selectedImage = select?.selectedOptions[0]?.dataset.image;
          const image = item.querySelector('[data-bundle-image]');
          if (selectedImage && image) { image.src = selectedImage; image.removeAttribute('srcset'); }
        });
        form.querySelector('[type="submit"]').disabled = !count;
      };
      form.addEventListener('change', sync); sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
